<app-table
  [lazy]="true"
  [cols]="columns"
  tableTitle="Edições Duplicadas"
  [addButton]="false"
  [exportPdf]="false"
  [exportExcel]="false"
  [refreshButton]="false"
  [service]="itOpsService"
  pageFunctionName="findDuplicatedEditionsTable"
  emptyMessage="Sem mais edições duplicadas no momento."
  selectionActionLabel="Corrigir"
  selectionActionTooltip="Marcar como resolvido"
  selectionActionIcon="pi pi-check"
  (emitSelection)="markAsResolved($event)"
  modelName="Registros"
  [defaultRows]="15"
  sortField="subscriberId"
  [sortOrder]="1"
/>
<p-confirmDialog />
<p-toast />
